import store from 'store/Store';
import BaseClass from 'components/BaseClass';
import Flag from 'components/Flag/Flag';
import React from 'react';
import {
    fontSizes, lineHeights, mediaQueries, space
} from 'style/config';
import localeUtils from 'utils/LanguageLocale';
import marketingFlagsUtil from 'utils/MarketingFlags';
import skuUtils from 'utils/Sku';
import { wrapComponent } from 'utils/framework';
import SwatchesEN from 'components/ProductPage/Swatches/locales/Swatches_en_US.js';
import SwatchesFR from 'components/ProductPage/Swatches/locales/Swatches_fr_CA.js';
import { Box } from 'components/ui';

const getText = localeUtils.getLocalisedDataFromResource(SwatchesEN, SwatchesFR);

class SwatchDescription extends BaseClass {
    constructor(props) {
        super(props);
        this.state = {};

        store.setAndWatch({ 'page.product': 'product' }, this, null, store.STATE_STRATEGIES.DIRECT_INIT);
    }

    getBadges = sku => {
        const flags = marketingFlagsUtil.getShadeFilterFlags(sku);

        return flags.length
            ? flags.map(({ text, backgroundColor }, index) => (
                <Flag
                    key={index.toString()}
                    data-at={Sephora.debug.dataAt('product_flag_label')}
                    children={text}
                    width='max-content'
                    backgroundColor={backgroundColor}
                    marginRight={1}
                />
            ))
            : null;
    };

    renderVariationContent = (sku, variationTypeDisplayName) => {
        if (!sku?.variationValue) {
            return ' ';
        }

        return (
            <>
                {variationTypeDisplayName && `${variationTypeDisplayName}: `}
                {sku.variationValue}
                {sku.variationDesc && ` - ${sku.variationDesc}`}
            </>
        );
    };

    render() {
        const { product } = this.state;

        const { hoveredSku, currentSku, skuSelectorType } = product;

        const hasVariation = product.variationType !== skuUtils.skuVariationType.NONE;
        const sku = hoveredSku || currentSku;
        const skuBadges = this.getBadges(sku);
        const currentSkuBadges = this.getBadges(currentSku);

        let { variationTypeDisplayName } = product;

        if (skuUtils.isFragrance(product, sku)) {
            variationTypeDisplayName = getText('size');
        }

        const shouldPreserveSpace = currentSku?.variationValue;

        if (!skuBadges && !currentSkuBadges && !shouldPreserveSpace) {
            return null;
        }

        return !(skuSelectorType === skuUtils.skuSwatchType.NONE || !hasVariation) ? (
            <div
                data-at={Sephora.debug.dataAt('sku_name_label')}
                css={[styles.wrapper, this.props.hasMinHeight && styles.wrapperMinHeight]}
            >
                {shouldPreserveSpace && (
                    <Box
                        is='span'
                        aria-hidden='true'
                        css={[styles.variationText, styles.hidden]}
                    >
                        {this.renderVariationContent(currentSku, variationTypeDisplayName)}
                    </Box>
                )}
                {(skuBadges || currentSkuBadges) && (
                    <Box
                        is='span'
                        aria-hidden='true'
                        css={styles.hidden}
                        children={skuBadges || currentSkuBadges}
                    />
                )}
                <Box css={styles.overlay}>
                    {shouldPreserveSpace && (
                        <Box
                            is='span'
                            css={[styles.variationText, !sku?.variationValue && styles.hidden]}
                        >
                            {this.renderVariationContent(sku, variationTypeDisplayName)}
                        </Box>
                    )}
                    {skuBadges}
                </Box>
            </div>
        ) : (
            <div data-at={Sephora.debug.dataAt('product_refinement')}>{skuBadges}</div>
        );
    }
}

const styles = {
    wrapper: {
        position: 'relative'
    },
    wrapperMinHeight: {
        [mediaQueries.md]: {
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitBoxPack: 'end',
            minHeight: fontSizes.base * lineHeights.tight * 2
        }
    },
    variationText: {
        marginRight: space[1],
        display: 'inline-block',
        minHeight: '1em'
    },
    hidden: {
        visibility: 'hidden'
    },
    overlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0
    }
};

export default wrapComponent(SwatchDescription, 'SwatchDescription');
